import React from 'react';

type Props = {
  heading: string
};

const AlertsHeading = function AlertsHeading(props: Props) {
  const { heading } = props;
  return (
    <h1 className="alerts-heading">{heading}</h1>
  );
};

export default AlertsHeading;
